import MainPaige from "./MainPage";

function App() {
  document.documentElement.style.setProperty('--animate-delay', '100ms');
  
  return <MainPaige />;
}

export default App;
